const resizeCarouselSliderElements = function(carouselId, type){
    let maxWidth = 0;
    let productTileInfoContainers = document.querySelectorAll(`.collection-carousel .collection-wrapper[data-id="${carouselId}"] .product-tile__info-container`);
    productTileInfoContainers.forEach((productTileInfoContainer) => {
      productTileInfoContainer.style.height = ``;
    })
    productTileInfoContainers.forEach((productTileInfoContainer) => {
      if (parseInt(productTileInfoContainer.offsetHeight) > maxWidth){
        maxWidth = parseInt(productTileInfoContainer.offsetHeight);
      }
    })
    productTileInfoContainers.forEach((productTileInfoContainer) => {
      productTileInfoContainer.style.height = `${maxWidth < 40 ? 40 : maxWidth}px`;
      })
  }

  const deleteRepeatedCarousels = function(){
    const items = document.querySelectorAll('.section-collection-carousel .collection-item.collection-wrapper');
    const seenHandles = new Set();
    items.forEach(item => {
        const handle = item.getAttribute('data-collection-handle');
        if (seenHandles.has(handle)) {
            item.remove();
        } else {
            seenHandles.add(handle);
        }
    });
  }

  const checkNavigationButtons = function(swiperInstance) {
    var currentBreakpoint = swiperInstance.currentBreakpoint;
    var slidesPerView = swiperInstance.params.slidesPerView;

    if (currentBreakpoint && swiperInstance.params.breakpoints[currentBreakpoint]) {
        slidesPerView = swiperInstance.params.breakpoints[currentBreakpoint].slidesPerView;
    }

    if (swiperInstance.slides.length <= slidesPerView) {
        swiperInstance.navigation.nextEl.style.display = 'none';
        swiperInstance.navigation.prevEl.style.display = 'none';
    } else {
        swiperInstance.navigation.nextEl.style.display = 'block';
        swiperInstance.navigation.prevEl.style.display = 'block';
    }
}

  const initCarouselSliders = function(event){
    let carouselSliders = document.querySelectorAll('.collection-carousel .carousel-wrapper');
    carouselSliders.forEach((carouselSlider, index) => {
    let carouselId = carouselSlider.closest('.collection-item.collection-wrapper').getAttribute('data-id');
    let prevElSelector = `.collection-item.collection-wrapper[data-id="${carouselId}"] .collection-carousel__prev`;
    let nextElSelector = `.collection-item.collection-wrapper[data-id="${carouselId}"] .collection-carousel__next`;
    
      var collectionCarouselSwiper = new Swiper(carouselSlider, {
        slidesPerView: 1.25,
        spaceBetween: 20,
        freeMode: true,
        preventClicks :true,
        a11y: false,
        navigation: {
          prevEl: prevElSelector,
          nextEl: nextElSelector,
        },
        breakpoints: {
          425: {
            slidesPerView: 1.5,
            spaceBetween: 20,
            navigation: {
              prevEl: prevElSelector,
              nextEl: nextElSelector,    
            }
          },
          700: {
            slidesPerView: 2.5,
            spaceBetween: 20,
            navigation: {
              prevEl: prevElSelector,
              nextEl: nextElSelector,    
            }
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
            navigation: {
              prevEl: prevElSelector,
              nextEl: nextElSelector,    
            }
          }
        },
        on: {
          init: function () {
            resizeCarouselSliderElements(carouselId);
            checkNavigationButtons(this);
          },
          resize: function () {
            checkNavigationButtons(this);
          }
        }
      })
      collectionCarouselSwiper.on('slideChange', function () {
        this.slides.forEach((slide) => {
          let showMore = slide.querySelector('.show-more');
          if(showMore && showMore.textContent == 'Close'){
            showMore.click();
          }
        })
      });
    })
}

window.onresize = function(){
  setTimeout(function(){
    let loops = document.querySelectorAll(`.collection-carousel .collection-wrapper`).length;
    for (let i = 0; i < loops; i++) {
      resizeCarouselSliderElements(i);
    }
  }, 400);
}

window.addEventListener('load', function(){
  deleteRepeatedCarousels();
  initCarouselSliders();
})
